
export default {
  namespaced: true,
  state: {
    searchTerm: '',
    searching: false,
    // Domain info
    domainData: {
      domainName: '',
      autoRenew: '',
      status: 'Active',
      startDate: '',
      expiryData: '',
      privacy: false,
      islocked: false,
      serviceState: '',
      term: ''
    },
    contacts: [],
    nameServers: [],
    tlds: []
  },
  getters: {
    domainData (state) {
      return state.domainData
    },
    contacts (state) {
      return state.contacts
    },
    nameServers (state) {
      return state.nameServers
    },
    hasRegisteredDomain (state) {
      if (state.domainData.serviceState === 'DomainRegistered') {
        return true
      }
      return false
    },
    hasPendingDomain (state) {
      if (state.domainData.serviceState === 'DomainRegistrationPending') {
        return true
      }
      return false
    },
    hasPendingDomainSelection (state) {
      if (state.domainData.serviceState === 'DomainSelectionRequired') {
        return true
      }
      return false
    },
    domainAllowedStatus (state) {
      if (state.domainData.serviceState !== 'DomainRegistered') {
        return true
      }
      if (state.domainData.status === 'Active' || state.domainData.status === 'Suspended') {
        return true
      }
      return false
    },
    isSearching (state) {
      return state.searching
    },
    getSearchTerm (state) {
      return state.searchTerm
    },
    getTlds (state) {
      return state.tlds
    }
  },
  mutations: {
    setSearching (state, isSearching) {
      state.searching = isSearching
    },
    setDomainsFound (state, domainsFound) {
      state.domainsFound = domainsFound
    },
    setDomainData (state, domainsData) {
      state.domainData = domainsData
    },
    setContacts (state, contacts) {
      state.contacts = contacts
    },
    setNameServers (state, servers) {
      state.nameServers = servers
    },
    setLoadingDomain (state, isLoading) {
      state.loadingDomain = isLoading
    },
    setSearchTerm (state, searcWord) {
      state.searchTerm = searcWord
    },
    setTlds (state, values) {
      state.tlds = values
    }
  },
  actions: {
    toggleSearchingStatus (ctx, status) {
      ctx.commit('setSearching', status)
    },
    getDomainsFound (ctx, status) {
      ctx.commit('setDomainsFound', status)
    },
    pushDomainData (ctx, status) {
      ctx.commit('setDomainData', status)
    },
    pushContacts (ctx, status) {
      ctx.commit('setContacts', status)
    },
    pushNameServers (ctx, status) {
      ctx.commit('setNameServers', status)
    },
    toggleLoadingDomain (ctx, status) {
      ctx.commit('setLoadingDomain', status)
    },
    setSearchTerm (ctx, status) {
      ctx.commit('setSearchTerm', status)
    },
    setTlds (ctx, status) {
      ctx.commit('setTlds', status)
    }
  }
}
